"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientTrackPayload = exports.buildTrackPayload = exports.analyticsOptions = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var qs = _interopRequireWildcard(require("querystring"));
var _reduxSegment = require("redux-segment");
var _objects = require("./objects");
var _reporter = require("./reporter");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var analyticsOptions = exports.analyticsOptions = {
  context: {
    ip: '0.0.0.0'
  },
  integrations: {
    Intercom: false,
    Marketo: false
  }
};
var pageProperties = function pageProperties(_ref) {
  var _global$location$sear;
  var _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params;
  // Clean search string from sensible data
  var unsafeQueryParameters = ['access_token', 'token_type', 'state'];
  var queryStr = global.location ? (_global$location$sear = global.location.search) === null || _global$location$sear === void 0 ? void 0 : _global$location$sear.replace('?', '') : '';
  var safeQueryParameters = _objects.omit.apply(void 0, [qs.parse(queryStr)].concat(unsafeQueryParameters));
  var safeSearchStr = qs.stringify(safeQueryParameters);
  return {
    search: safeSearchStr ? "?".concat(safeSearchStr) : '',
    query: safeQueryParameters,
    params: params
  };
};

// redux-segment payload
var analyticsPayload = function analyticsPayload(eventType, eventPayload) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var allOptions = (0, _objects.deepMerge)(analyticsOptions, options);
  return {
    meta: {
      analytics: {
        eventType: eventType,
        eventPayload: _objectSpread(_objectSpread({}, eventPayload), {}, {
          options: (0, _objects.deepMerge)(allOptions, {
            context: {
              page: pageProperties({})
            }
          })
        })
      }
    }
  };
};

// events may be a string or an object specifying name and required properties
var getEventName = function getEventName(event) {
  return (0, _typeof2.default)(event) === 'object' ? event.name : event;
};

// adds a configured prefix to the event name (e.g EXC clicked some button)
var addEventPrefix = function addEventPrefix(eventName) {
  return "EXC ".concat(eventName);
};

// validates event existence and required properties and executes payload strategy
var buildTrackPayload = exports.buildTrackPayload = function buildTrackPayload(payloadStrategy) {
  return function (_ref2) {
    var eventSchema = _ref2.eventSchema,
      properties = _ref2.properties,
      userId = _ref2.userId,
      options = _ref2.options,
      context = _ref2.context;
    if (!eventSchema) {
      (0, _reporter.report)('Event schema does not exist');
      return {};
    }
    var name = getEventName(eventSchema);
    var required = typeof eventSchema === 'string' ? [] : eventSchema.required || [];
    if (!required.every(function (propName) {
      return properties[propName] !== undefined;
    })) {
      (0, _reporter.report)("Event \"".concat(name, "\" should have the following properties: ").concat(required.join(', ')));
    }
    return payloadStrategy({
      name: name,
      properties: properties,
      userId: userId,
      context: context,
      options: options
    });
  };
};

// payload for events tracked in the browser
var clientTrackPayload = exports.clientTrackPayload = buildTrackPayload(function (_ref3) {
  var name = _ref3.name,
    properties = _ref3.properties,
    context = _ref3.context,
    options = _ref3.options;
  return analyticsPayload(_reduxSegment.EventTypes.track, {
    event: addEventPrefix(name),
    properties: context ? _objectSpread(_objectSpread({}, properties), {}, {
      context: context
    }) : properties
  }, options);
});
//# sourceMappingURL=analytics.js.map